import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthenticationConsumer } from '../Contexts/AuthenticationContext';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <AuthenticationConsumer>
    {({ authenticated, busy }) => {
      if (busy) {
        return null;
      }

      return (
        <Route
          {...rest}
          render={props =>
            authenticated ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: '/login',
                  state: { from: props.location }
                }}
              />
            )
          }
        />
      );
    }}
  </AuthenticationConsumer>
);

export default PrivateRoute;
